// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The token for the form component registry.
 */
export const IFormRendererRegistry = new Token('@jupyterlab/ui-components:IFormRendererRegistry', 'A service for settings form renderer registration.');
/**
 * The ILabIconManager token.
 */
export const ILabIconManager = new Token('@jupyterlab/ui-components:ILabIconManager', 'A service to register and request icons.');
//# sourceMappingURL=tokens.js.map